import React from 'react';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';

import FilterForm from '../../../../../components/form/base/FilterForm';
import TextField from '../../../../../components/form/elements/TextField';
import { TEXT_FIELD_COLOR, TEXT_FIELD_TYPE, TEXT_FIELD_VARIANT } from '../../../../../components/form/enum/formProps';
import { CategoryFilterValues } from '../../../model/categoryModel';
import * as Actions from '../../../redux/categoryActions';
import useDataGridProgressContext from '../../../../../components/progress/DataGridProgress/context/DataGridProgressContext';
import FormCategoryFilter from '../../../../../components/form/custom/CategoryFilter';
import { objectHelper } from '../../../../../shared/utils/objectHelper';

interface CategoryFilterProps {
  categoryId?: number;
}

const initialValues: CategoryFilterValues = {
  id: '',
  name: '',
  parent: '',
  categoryOne: {
    value: '',
    key: '',
  },
  categoryTwo: {
    value: '',
    key: '',
  },
  categoryThree: {
    value: '',
    key: '',
  },
};

const validationSchema = Yup.object().shape({
  id: Yup.number().min(1, 'validation.too_small'),
  name: Yup.string().min(2, 'validation.too_short'),
  parent: Yup.string().ensure(),
  categoryOne: Yup.object().shape({
    value: Yup.string().ensure(),
    key: Yup.string().ensure(),
  }),
  categoryTwo: Yup.object().shape({
    value: Yup.string().ensure(),
    key: Yup.string().ensure(),
  }),
  categoryThree: Yup.object().shape({
    value: Yup.string().ensure(),
    key: Yup.string().ensure(),
  }),
});

const CategoryFilter: React.FC<CategoryFilterProps> = (props) => {
  const dispatch = useDispatch();
  const dataGridProgressContext = useDataGridProgressContext();

  return (
    <FilterForm<CategoryFilterValues>
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values: CategoryFilterValues) => {
        dataGridProgressContext.show();
        dispatch(
          Actions.getAllCategories(
            objectHelper.removeByKeys<CategoryFilterValues>(
              ['categoryOne', 'categoryTwo', 'categoryThree'],
              objectHelper.removeEmptyValues<CategoryFilterValues>({
                ...values,
                parent: values.categoryThree?.key
                  ? values.categoryThree?.key
                  : values.categoryTwo?.key
                  ? values.categoryTwo?.key
                  : values.categoryOne?.key,
              }),
            ),
          ),
        );
      }}
      disabled={dataGridProgressContext.visibility}
    >
      <TextField
        name="id"
        label="category.id"
        type={TEXT_FIELD_TYPE.NUMBER}
        color={TEXT_FIELD_COLOR.PRIMARY}
        variant={TEXT_FIELD_VARIANT.STANDARD}
      />
      <TextField
        name="name"
        label="category.name"
        type={TEXT_FIELD_TYPE.TEXT}
        color={TEXT_FIELD_COLOR.PRIMARY}
        variant={TEXT_FIELD_VARIANT.STANDARD}
      />
      <FormCategoryFilter parentId={props.categoryId} removeCategoryThree={true} />
    </FilterForm>
  );
};

export default CategoryFilter;
